import { createContext, useContext, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import usePrevious from 'utils/usePrevious';
import { jsx as _jsx } from "react/jsx-runtime";
export var LocalNavContext = /*#__PURE__*/createContext({
  localNav: false
});

// Context that tracks whether the user has navigated to a new page. This does not handle
// people going back in their browser history.
export default function LocalNavContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    localNav = _useState[0],
    setLocalNav = _useState[1];
  var pathName = usePathname();
  var oldPathname = usePrevious(pathName);
  useEffect(function () {
    if (!localNav && oldPathname && oldPathname !== pathName) {
      setLocalNav(true);
    }
  }, [localNav, oldPathname, pathName]);
  return /*#__PURE__*/_jsx(LocalNavContext.Provider, {
    value: {
      localNav: localNav
    },
    children: children
  });
}
export function useLocalNavContext() {
  var ctx = useContext(LocalNavContext);
  if (ctx === undefined) {
    throw new Error('useLocalNavContext must be used within a LocalNavContextProvider');
  }
  return ctx.localNav;
}